import { useContext, useEffect } from "react";
import MapContext from "../Map/MapContext";
import OLTileLayer from "ol/layer/Tile";
import { connect } from "react-redux";
import { osm, ESRI, FondGris, Orthophoto, Topographie } from "../Source";

const TileLayer = ({ zIndex = 0, fonddecarte }) => {
	const { map } = useContext(MapContext);

	useEffect(() => {
		if (!map) return;
		var source = "";
		switch (fonddecarte) {
			case "ESRI":
			default:
				source = ESRI();
				break;
			case "OpenStreetMap":
				source = osm();
				break;
			case "Orthophoto":
				source = Orthophoto();
				break;
			case "Fond gris":
				source = FondGris();
				break;
			case "Topographie":
				source = Topographie();
				break;
		}
		
		let tileLayer = new OLTileLayer({
			source,
			zIndex,
			type:"TILE"
		});

		map.addLayer(tileLayer);
		tileLayer.setZIndex(zIndex);

		return () => {
			if (map) {
				map.removeLayer(tileLayer);
			}
		};
		// eslint-disable-next-line
	}, [map, fonddecarte]);

	return null;
};


function mapStateToProps(state) {
	return {
		fonddecarte: state.fonddecarte
	}
}

export default connect(mapStateToProps)(TileLayer);